export default __webpack_public_path__ + "static/media/items_shw01.eab0d5da.jpg";